var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15 12.5L10 7.5L5 12.5","stroke":"#667085","stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }